import { Link, ListItem } from '@mui/material';
import { ExternalLink } from '@barracuda/shared';
import { NavLink } from 'react-router-dom';
import { useLocalizedMatch } from '@/hooks/useLocalizedMatch';
import { useAppContext } from '@/context/App.context';
import { getLinkActiveStyle, linkStyle, navbarListItem } from './HeaderNavbar.style';

export const HeaderNavBarLink = ({
  link
}: {
  link: { label: string; to: string; replace?: boolean; key: string; end?: boolean };
  index: number;
}) => {
  const { language } = useAppContext();
  const isActive = useLocalizedMatch(link.to) !== null;

  const item = !link.replace ? (
    <Link
      component={NavLink}
      to={`/${language}${link.to}`}
      end={link.end ?? true}
      sx={[linkStyle, getLinkActiveStyle(isActive)]}
    >
      {link.label}
    </Link>
  ) : (
    <ExternalLink href={link.to} sx={linkStyle}>
      {link.label}
    </ExternalLink>
  );

  return (
    <ListItem key={link.key} disablePadding sx={navbarListItem}>
      {item}
    </ListItem>
  );
};
